import { Component, Input, OnInit } from '@angular/core';
import { RealmData } from '../../services/environment.service';

@Component({
    selector: 'app-pg-realm-card',
    templateUrl: './pg-realm-card.component.html',
    styleUrls: ['./pg-realm-card.component.scss'],
    standalone: false
})
export class PgRealmCardComponent implements OnInit {
    constructor() { }

    @Input() realmData:RealmData;

    realmName:string = null;

    ngOnInit(): void {
        this.realmName = null;

        if(this.realmData != null) {
            if(this.realmData.id != null) {
                this.realmName = this.realmData.name;
            }
        }
    }

    hasContacts() {
        return Object.keys(this.realmData.contacts).length > 0
    }

    getImageFit() {
        if(window.innerWidth >= 768) return 'contain'
        else return 'cover'
    }
}
